import './index.css';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { View } from '../../../component';
import EventEmitter from '../../../utilities/EventEmitter';
import { getMatchStatus, getRouteObjByGame, isSmartPhone } from '../../../utilities/helper';
import useGame from '../../../utilities/hooks/game';
import { ContestResultCard } from '../../component';
import { useLink } from 'react-router-stack';
import constants from '../../../constants';
import DefaultContainer from '../../../container/default_container';
import MyContestListMWeb from './index_mWeb';

const MyContestList = () => {
  const dispatch = useDispatch();
  const navigate = useLink();
  const {
    gameType,
    item: matchItem,
    myTeamList = [],

    fantasyMatchClick
  } = useGame();
  const { myContestList: fantasyCricketMyContestList } = useSelector(
    (state: any) => state.fantasy_cricket
  );
  const { myContestList: fantasyFootballMyContestList } = useSelector(
    (state: any) => state.fantasy_football
  );

  const [error, setError] = useState(false);

  const totalTeamsCount = myTeamList.length;

  const { joined = false, tabType = 'FIXTURE', verified = false } = matchItem;
  const [challenges, setChallenges] = useState([] as any);

  useEffect(() => {
    getMyJoinedContestAPI();
    getMyMatchTeamListAPI();
    EventEmitter.on('updateMyContests', getMyJoinedContestAPI_);
    return () => {
      EventEmitter.off('updateMyContests', getMyJoinedContestAPI_);
    };
  }, []);

  const getMyJoinedContestAPI_ = () => getMyJoinedContestAPI();

  const getMyMatchTeamListAPI = async () => {};

  const getMyJoinedContestAPI = async (skip = 0) => {
    let result: any = [];
    if (gameType === constants.GameType.FANTASY_CRICKET) {
      result = [...fantasyCricketMyContestList[matchItem._id]];
    }
    if (gameType === constants.GameType.FANTASY_FOOTBALL) {
      result = [...fantasyFootballMyContestList[matchItem._id]];
    }

    if (!error && result) {
      if (skip === 0) {
        setChallenges(result);
      } else {
        setChallenges((challenges: any): any[] => [...challenges, ...result]);
      }
      setError(false);
    } else {
      setError(true);
    }
  };

  const onPressCard = (contest: any, completed = false) => {
    dispatch(
      fantasyMatchClick({
        data: {
          ...matchItem,
          contest,
          completed,
          joined,
          tabType,
          totalTeamsCount: totalTeamsCount
        }
      })
    );
    navigate.push(getRouteObjByGame(gameType)['contest_details']);
  };

  const { teamA, teamB, status } = matchItem;

  if (isSmartPhone) {
    return <MyContestListMWeb onPressCard={onPressCard} />;
  }

  return (
    <DefaultContainer isWelcomeMessage={false}>
      <div className="my-contest-list-wrapper">
        {/* <View
          style={{
            marginTop: '10px',
            marginBottom: '10px',
            height: '200px'
          }}>
          <DashboardBanner />
        </View> */}
        <View className="my-contest-list-primary-container">
          <div className="my-contest-list-header">
            <p>{`${teamA?.shortName} vs ${teamB?.shortName}`}</p>
            {''}
            <p style={{ paddingLeft: '10px' }}>{getMatchStatus(status, verified)}</p>
          </div>
          <div className="my-contest-list-card-wrapper">
            {challenges.map((item: any, idx: any) => (
              <div
                key={idx}
                style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <ContestResultCard
                  contest={item}
                  onPressCard={() => onPressCard(item, true)}
                  myTeamList={myTeamList}
                  matchVerifiedStatus={verified}
                />
              </div>
            ))}
          </div>
        </View>
      </div>
    </DefaultContainer>
  );
};

export default MyContestList;
